import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notFoundHeader: {
		id: 'servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-header',
		defaultMessage: "Can't find this article",
		description: 'Error header shown when an article could not be found.',
	},
	notFoundMessage: {
		id: 'servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-message',
		defaultMessage:
			'You may not have permission to view this article, you may not have permission to access Confluence, or this article may not exist.',
		description: 'Error message shown when an article could not be found.',
	},
	genericHeader: {
		id: 'servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-header',
		defaultMessage: 'Something went wrong',
		description: 'Error header shown when an article could not be loaded.',
	},
	genericMessage: {
		id: 'servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-message',
		defaultMessage: "We couldn't load this article. Please refresh after a few minutes.",
		description: 'Error message shown when an article could not be loaded.',
	},
	genericSearchCta: {
		id: 'servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-search-cta',
		defaultMessage: 'Browse all articles',
		description: 'Call to action when an error is displayed on the article page',
	},
});
